import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import TooltipTitle from './TooltipTitle';
import TooltipHeadingText from './TooltipHeadingText';
import { trackInteraction } from '../../utils/usageTracker';
import { OPEN_TOOLTIP } from '../../constants/trackingConstants';
import { jsx as _jsx } from "react/jsx-runtime";
function ToolAccessTooltipBase(props) {
  const {
    children,
    tooltipProps = {},
    toolAccess
  } = props;
  const onOpen = e => {
    if (e.target.value) {
      trackInteraction(OPEN_TOOLTIP);
      toolAccess.fetchRequest();
    }
  };
  return /*#__PURE__*/_jsx(Tooltip, Object.assign({
    use: "longform",
    maxInlineSize: "250px"
  }, tooltipProps, {
    onOpenChange: onOpen,
    headingText: /*#__PURE__*/_jsx(TooltipHeadingText, {
      toolAccess: toolAccess
    }),
    title: /*#__PURE__*/_jsx(TooltipTitle, {
      toolAccess: toolAccess
    }),
    children: children
  }));
}
export default ToolAccessTooltipBase;